<header id="addPhoneHeader" mat-dialog-title>
  <h1>
    <span>{{ 'uix.components.phone.title' | translate }}</span>
    <mat-icon>phone</mat-icon>
  </h1>
</header>
<section mat-dialog-content class="message-container">
  <mat-form-field appearance="outline" data-form-field="phone">
    <mat-label class="label">{{ 'uix.components.phone.label' | translate }}</mat-label>
    <input id="userPhoneInput" type="text" matInput required [formControl]="phoneFormControl" />
    @if (phoneFormControl.hasError('maxlength')) {
      <mat-error data-form-field-error="maxlength">
        {{ 'commons.validations.maxLength' | translate }}
      </mat-error>
    }
    @if (phoneFormControl.hasError('required')) {
      <mat-error data-form-field-error="required">
        {{ 'commons.validations.required' | translate }}
      </mat-error>
    }
  </mat-form-field>
</section>
<section mat-dialog-actions align="end">
  <!-- This fills the remaining space of the current row -->
  <span class="fill-remaining-space"></span>

  <button id="cancelBtn" mat-button (click)="onNoClick()" cdkFocusInitial>{{ 'commons.btn.cancel' | translate }}</button>
  <button id="confirmBtn" mat-raised-button [mat-dialog-close]="phoneFormControl.value" [disabled]="formControlHasErrors()" color="primary">
    {{ 'commons.btn.add' | translate }}
  </button>
</section>
